import { Dispatch } from "@reduxjs/toolkit";
import { Action } from "../core/actions";
import { State } from "../core/reducers";
import { connect } from "react-redux";
import RoleAccessProviderComponent from "./RoleAccessProviderComponent";

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({});

const mapStateToProps = (state: State) => ({
    roles: state.roles
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RoleAccessProviderComponent);
